import { Component, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { UserStatusesService } from '../user-statuses.service';
import { AdminUsersService } from './admin-users.service';
import { User } from 'web-common/src/app/user/user';
import { NotificationsService } from 'web-common/src/app/notifications.service';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { AdminModalFactoryComponent } from './modal-factory/admin-modal-factory.component';
import { ModalResponseResult } from 'web-common/src/app/modals/modal-factory/modal-response-result';
import { ModalResponseData } from 'web-common/src/app/modals/modal-factory/modal-response-data';
import { AdminAvailableModals} from './modal-factory/admin-available-modals';
import * as moment from 'moment';
import {SharedDataService} from '../invited-shared-data.service';

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html'
})
export class AdminUsersComponent implements OnInit {
  maxUsersReport = 10000;
  pageSize = 50;
  currentPage: number;
  adminUser: User;
  users = [];
  totalCountOfUsers = 0;
  start = 0;
  showSpinner = false;
  showCSVSpinner = false;
  email = '';
  emailSearch = '';
  end = this.pageSize;
  singleUser: User = null;
  selectedTab = 'users';
  selectedUsers = {
    userIds : [],
    allUsersOnPage: false,
    allInstitutionUsers: false
  };
  bulkActionToPerform = '';
  showDisabled = true;
  activeCount = 0;
  nonActiveCount = 0;
  totalCount = 0;
  deactivatedCount = 0;
  adminCount = 0;
  lastActiveAll = $localize`All`;
  statusOptionEnabled = $localize`Enabled`;
  statusOptionDisabled = $localize`Disabled`;
  filterCountAllLabel = $localize`(all)`;
  lastActiveLabel: string = this.lastActiveAll;
  lastActive: string = 'ALL';
  filtersVisible = false;
  adminOnly = false;
  private searchTimer: any;
  private isTimerExpired = false;
  protected readonly Object = Object;
  isRoleIndeterminate = false;
  isAreaIndeterminate = false;
  isAdditionalIndeterminate = false;
  additionalProfileInformationLabel: string;
  isIndeterminateUsers = false;
  currentSortField = 'email';
  currentSortType = 'ASC';
  disableApplyButton = true;
  showAdditionalProfileInformation = false;

  // Invited vars
  invitedEmail = '';
  invitedPageSize = 50;
  invitedCurrentPage = 0;

  statusOptions = [
    { label: this.statusOptionEnabled, checked: true },
    { label: this.statusOptionDisabled, checked: true }
  ];
  lastActiveOptions: Record<string, string> = {
    'ALL': this.lastActiveAll,
    'TODAY': $localize`Today`,
    'Last7Days': $localize`last 7 days`,
    'Last1Month': $localize`last 1 month`,
    'Last12Months': $localize`last 12 months`,
    'Last24Months': $localize`last 24 months`,
  };

  roleOptions = [];
  areaOptions = [];
  additionalOptions = [];

  pageSizeOptions = [25, 50, 100];

  @ViewChild('toggleAdminErrorTemplate', { static: true }) toggleAdminErrorTemplate: TemplateRef<any>;
  @ViewChild('userStatusErrorTemplate', { static: true }) userStatusErrorTemplate: TemplateRef<any>;

  @ViewChild('toasterSuccessGrantAdmin', { static: true }) toasterSuccessGrantAdmin: TemplateRef<any>;
  @ViewChild('toasterSuccessRemoveAdmin', { static: true }) toasterSuccessRemoveAdmin: TemplateRef<any>;
  @ViewChild('toasterSuccessDeactivateUser', { static: true }) toasterSuccessDeactivateUser: TemplateRef<any>;
  @ViewChild('toasterSuccessReactivateUser', { static: true }) toasterSuccessReactivateUser: TemplateRef<any>;
  @ViewChild('toasterSuccessGrantAdminBulk', { static: true }) toasterSuccessGrantAdminBulk: TemplateRef<any>;
  @ViewChild('toasterSuccessRemoveAdminBulk', { static: true }) toasterSuccessRemoveAdminBulk: TemplateRef<any>;
  @ViewChild('toasterSuccessDeactivateUserBulk', { static: true }) toasterSuccessDeactivateUserBulk: TemplateRef<any>;
  @ViewChild('toasterSuccessReactivateUserBulk', { static: true }) toasterSuccessReactivateUserBulk: TemplateRef<any>;
  @ViewChild('toasterFailGrantAdmin', { static: true }) toasterFailGrantAdmin: TemplateRef<any>;
  @ViewChild('toasterFailRemoveAdmin', { static: true }) toasterFailRemoveAdmin: TemplateRef<any>;
  @ViewChild('toasterFailDeactivateUser', { static: true }) toasterFailDeactivateUser: TemplateRef<any>;
  @ViewChild('toasterFailReactivateUser', { static: true }) toasterFailReactivateUser: TemplateRef<any>;
  @ViewChild('toasterFailGrantAdminBulk', { static: true }) toasterFailGrantAdminBulk: TemplateRef<any>;
  @ViewChild('toasterFailRemoveAdminBulk', { static: true }) toasterFailRemoveAdminBulk: TemplateRef<any>;
  @ViewChild('toasterFailDeactivateUserBulk', { static: true }) toasterFailDeactivateUserBulk: TemplateRef<any>;
  @ViewChild('toasterFailReactivateUserBulk', { static: true }) toasterFailReactivateUserBulk: TemplateRef<any>;
  @ViewChild('toasterActionUndoneSuccess', { static: true }) toasterActionUndoneSuccess: TemplateRef<any>;
  @ViewChild(AdminModalFactoryComponent, { static: true }) modalFactory: AdminModalFactoryComponent;

  constructor(
    private route: ActivatedRoute,
    private userStatusesService: UserStatusesService,
    private adminUserService: AdminUsersService,
    private notifications: NotificationsService,
    private sharedDataService: SharedDataService) {}

  ngOnInit() {
    this.getPage();
    this.getSummaryTable();
    this.showSpinner = true;
    this.adminUser = this.route.parent.snapshot.data['user'] as User;
    this.loadDropdownsFilters();
    this.sharedDataService.emailInvitedSearch$.subscribe((email) => (this.invitedEmail = email));
    this.sharedDataService.pageSize$.subscribe((pageSize) => (this.invitedPageSize = pageSize));
    this.sharedDataService.currentPage$.subscribe((currentPage) => (this.invitedCurrentPage = currentPage));
  }

  loadDropdownsFilters(): void {
    const discountGroupResponse = this.route.parent.snapshot.data['user'].discountGroup as {
      roles: string[];
      areaOfFocus: string[];
    };

    this.roleOptions = [
      { label: 'All', checked: true },
      ...discountGroupResponse.roles.map(role => ({ label: role, checked: true }))
    ];

    this.areaOptions = [
      { label: 'All', checked: true },
      ...discountGroupResponse.areaOfFocus.map(area => ({ label: area, checked: true }))
    ];

    this.showAdditionalProfileInformation = !!this.adminUser.discountGroup.additionalProfileInformation &&
      !!this.adminUser.discountGroup.additionalProfileInformation.label;

    if (this.showAdditionalProfileInformation) {
      this.additionalProfileInformationLabel = this.adminUser.discountGroup.additionalProfileInformation.label;

      if (this.adminUser.discountGroup.additionalProfileInformation.answers) {
        this.additionalOptions = [
          { label: 'All', checked: true },
          ...this.adminUser.discountGroup.additionalProfileInformation.answers.map(answer => ({ label: answer, checked: true }))
        ];
      }
    } else {
      this.additionalProfileInformationLabel = '';
      this.additionalOptions = [];
    }
  }


  selectLastActive(option: string): void {
    this.lastActive = option;
    this.lastActiveLabel = this.lastActiveOptions[option];
    this.getPage();
  }

  showFilters(): void {
    this.filtersVisible = !this.filtersVisible;
  }
  onAdminOnlyChange(): void {
    this.adminOnly = !this.adminOnly;
  }

  applyFilters(): void {
    this.currentPage = 0;
    this.start = 0;
    this.getPage(this.currentPage, this.emailSearch);
  }

  getSelectedFilters(optionList): string[] {
    if (optionList.length > 0 && optionList[0].checked) {
      return [];
    }
    return optionList
      .filter(option => option.checked)
      .map(option => option.label);
  }

  private updateAllCheckboxState(newValue: boolean, option: any, listToUpdate: any[]) {
    const allOption = listToUpdate[0];
    const checkedOptions = listToUpdate.slice(1).filter(opt => opt.checked);
    const allUnchecked = listToUpdate.slice(1).every(opt => !opt.checked);

    let isIndeterminate = false;

    if (option.label === 'All') {
      listToUpdate.forEach(opt => opt.checked = newValue);
      isIndeterminate = false;
    } else {
      if (allOption.checked && newValue === true) {
        listToUpdate.forEach(opt => opt.checked = true);
      } else if (allUnchecked) {
        allOption.checked = false;
        isIndeterminate = false;
      } else {
        const allChecked = checkedOptions.length === listToUpdate.length - 1;
        allOption.checked = allChecked;
        isIndeterminate = !allChecked && !allUnchecked;
      }
    }

    return { listToUpdate, isIndeterminate };
  }

  onRoleOptionChange(newValue: boolean, option: any) {
    const labelToUpdate = option.label;
    const updatedRoleOptions = this.roleOptions.map(opt =>
      opt.label === labelToUpdate ? { ...opt, checked: newValue } : opt
    );

    const { listToUpdate, isIndeterminate } = this.updateAllCheckboxState(newValue, option, [...updatedRoleOptions]);
    this.roleOptions = listToUpdate;
    this.isRoleIndeterminate = isIndeterminate;
  }

  onAreaOptionChange(newValue: boolean, option: any) {
    const labelToUpdate = option.label;
    const updatedAreaOptions = this.areaOptions.map(opt =>
      opt.label === labelToUpdate ? { ...opt, checked: newValue } : opt
    );

    const { listToUpdate, isIndeterminate } = this.updateAllCheckboxState(newValue, option, [...updatedAreaOptions]);
    this.areaOptions = listToUpdate;
    this.isAreaIndeterminate = isIndeterminate;
  }

  onAdditionalOptionChange(newValue: boolean, option: any) {
    const labelToUpdate = option.label;
    const updatedAdditionalOptions = this.additionalOptions.map(opt =>
      opt.label === labelToUpdate ? { ...opt, checked: newValue } : opt
    );

    const { listToUpdate, isIndeterminate } = this.updateAllCheckboxState(newValue, option, [...updatedAdditionalOptions]);
    this.additionalOptions = listToUpdate;
    this.isAdditionalIndeterminate = isIndeterminate;
  }



  private selectedSummary(options): string {
    const selectedCount = options.slice(1).filter(option => option.checked).length;

    if (selectedCount === options.length - 1) {
      return ' ' + this.filterCountAllLabel;
    } else if (selectedCount > 0) {
      return ` (${selectedCount})`;
    } else {
      return '';
    }
  }

  selectedRolesSummary(): string {
    return this.selectedSummary(this.roleOptions);
  }

  selectedAreaSummary(): string {
    return this.selectedSummary(this.areaOptions);
  }

  selectedAdditionalSummary(): string {
    return this.selectedSummary(this.additionalOptions);
  }

  clearAllFilters(): void {
    this.roleOptions.forEach(opt => (opt.checked = true));
    this.areaOptions.forEach(opt => (opt.checked = true));
    this.additionalOptions.forEach(opt => (opt.checked = true));
    this.statusOptions.forEach(opt => (opt.checked = true));
    this.adminOnly = false;
    this.disableApplyButton = true;
    this.isRoleIndeterminate = false;
    this.isAreaIndeterminate = false;
    this.isAdditionalIndeterminate = false;
    this.getPage(this.currentPage,  this.emailSearch);
  }

  filtersChanged(): boolean {
    if (this.adminOnly) {
      this.disableApplyButton = false;
      return true;
    }

    const listsToCheck = [this.roleOptions, this.areaOptions, this.additionalOptions, this.statusOptions];

    const hasUncheckedOption = listsToCheck.some(list => list.some(opt => !opt.checked));

    if (hasUncheckedOption) {
      this.disableApplyButton = false;
    }

    return hasUncheckedOption;
  }


  getStatusText() {
    const selectedStatuses = this.statusOptions
      .filter(option => option.checked)
      .map(option => option.label);

    return selectedStatuses.length === this.statusOptions.length
      ? this.filterCountAllLabel
      : '(' + selectedStatuses.length + ')';
  }

  sortTable(field: string): void {
    if (this.currentSortField === field) {
      this.currentSortType = this.currentSortType === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.currentSortType = 'ASC';
      this.currentSortField = field;
    }

    this.getPage(this.currentPage, this.emailSearch);
  }

  onPageSizeChange(): void {
    this.getPage(this.currentPage, this.emailSearch);
  }

  hasActions(user) {
    return this.adminUser.id !== user.id;
  }

  public isUserActive(lastActiveTimestamp: number): boolean {
    const twelveMonthsAgo = new Date();
    twelveMonthsAgo.setMonth(twelveMonthsAgo.getMonth() - 12);

    const lastActiveDate = new Date(lastActiveTimestamp);

    return lastActiveDate >= twelveMonthsAgo;
  }

  selectTab(tab: string) {
    this.selectedTab = tab;
  }

  private extractData = data => {
    this.totalCountOfUsers = data.data.totalItems;
    this.currentPage = data.data.currentPage;
    this.end =  parseInt((this.start + this.pageSize > this.totalCountOfUsers ?
      this.totalCountOfUsers : this.start + this.pageSize).toString(), 10);
    this.users = data.data.userDataList;

    this.showSpinner = false;
    const self = this;
    for (let usrData of this.users) {
      if (self.selectedUsers.allInstitutionUsers) {
        usrData.user.selected = true;
      }
      if (usrData.user.firstName == null) {
        usrData.user.firstName = '';
      }
      if (usrData.user.lastName == null) {
        usrData.user.lastName = '';
      }
    }
    // If all users have been programmatically selected on this page
    this.checkUsersOnCurrentPage();
    this.getSummaryTable();
    setTimeout(this.updateMargins, 0);
  }

  reset = () => {
    this.email = '';
    this.emailSearch = '';
    this.getPage();
  }

  private getPage(start = 0, email = '', clearSelection = true) {
    if (clearSelection) {
      this.deselectUsers();
    }
    this.email = email || this.emailSearch || '';
    this.showSpinner = true;
    this.userStatusesService.fetchUsers(
      this.currentPage,
      this.email,
      this.pageSize,
      this.showDisabled,
      this.lastActive,
      this.statusOptions.find(opt => opt.label === this.statusOptionDisabled).checked,
      this.statusOptions.find(opt => opt.label === this.statusOptionEnabled).checked,
      this.adminOnly,
      this.getSelectedFilters(this.roleOptions),
      this.getSelectedFilters(this.areaOptions),
      this.getSelectedFilters(this.additionalOptions),
      this.currentSortField,
      this.currentSortType
    ).subscribe(this.extractData);
  }

  public getUsers() {
    this.deselectUsers();
    this.showSpinner = true;
    this.getPage();
  }

  private extractSummaryData = data => {
    const summary = data.data;

    this.activeCount = summary['Total active users'];
    this.deactivatedCount = summary['Total Deactivated users'];
    this.nonActiveCount = summary['Total non-active users'];
    this.totalCount = summary['Total users'];
    this.adminCount = summary['Total admins'];
  }

  public getSummaryTable() {
   this.userStatusesService.getSummaryTableData().subscribe(this.extractSummaryData);
  }

  public getUserStatusText(user: any) {
    const status = user.isInstitutionAdmin ? 'Admin' : '';
    const disabledStatus = user.disabled ? 'Disabled' : 'Enabled';

    return `${disabledStatus}${status ? '/' + status : ''}`;
  }

  public downloadCSVFile() {
    this.showCSVSpinner = true;

    const handleError = (error: any) => {
      console.error('Error downloading the file: ', error);
      this.notifications.error('Error downloading the file');
    };

    const downloadFileCallback = (data: any) => {
      if (!data) {
        this.showEmailNotification();
      } else {
        this.downloadFile(data);
      }
    };

      if (this.selectedTab === 'invited') {
        this.adminUserService.exportInvited(this.invitedCurrentPage, this.invitedPageSize, this.invitedEmail)
          .subscribe(downloadFileCallback, handleError);
      } else {
          let byAdminsEmail: boolean = (this.totalCountOfUsers < this.maxUsersReport) ? false : true;
          this.adminUserService.exportUsers(
            this.currentPage,
            this.email,
            this.pageSize,
            this.showDisabled,
            this.lastActive,
            this.statusOptions.find(opt => opt.label === this.statusOptionDisabled).checked,
            this.statusOptions.find(opt => opt.label === this.statusOptionEnabled).checked,
            this.adminOnly,
            this.getSelectedFilters(this.roleOptions),
            this.getSelectedFilters(this.areaOptions),
            this.getSelectedFilters(this.additionalOptions),
            this.currentSortField,
            this.currentSortType,
            byAdminsEmail)
            .subscribe(downloadFileCallback, handleError);

      }
  }
  private showEmailNotification = () => {
    this.showCSVSpinner = false;
    this.singleAction(this.adminUser, 'report');
  }

  private downloadFile(data: any) {
    const nav = (window.navigator as any);
    const bomChar = '\ufeff';
    const charset = 'text/csv;charset=utf-8;'
    this.showCSVSpinner = false;
    let blob = new Blob([bomChar + data], { type: charset });
    let url = window.URL.createObjectURL(blob);

    if (nav.msSaveOrOpenBlob) {
      nav.msSaveBlob(blob, this.getFileFullName());
    } else {
      let a = document.createElement('a');
      a.href = url;
      a.download = this.getFileFullName();
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    window.URL.revokeObjectURL(url);
  }

  private getFileFullName(): string {
    let date = new Date();
    let formattedDate = moment(date).format('YYYY-MM-DD');
    let fileNamePrefix = this.selectedTab === 'invited' ? 'RefWorksInvites' : 'RefWorksUsers';

    return `${fileNamePrefix}-${formattedDate}.csv`;
  }

  public bulkAction(action: string) {
    this.bulkActionToPerform = action;
    this.singleUser = null;
    switch (action) {
      case 'MAKE_ADMIN':
        this.modalFactory.createModal(AdminAvailableModals.CONFIRM_MAKE_USER_ADMIN, this.selectedUsers.userIds.length);
        break;
      case 'REVOKE_ADMIN':
        this.modalFactory.createModal(AdminAvailableModals.CONFIRM_REMOVE_USER_ADMIN, this.selectedUsers.userIds.length);
        break;
      case 'ENABLE':
        this.modalFactory.createModal(AdminAvailableModals.CONFIRM_ENABLE_USER, this.selectedUsers.userIds.length);
        break;
      case 'DISABLE':
        this.modalFactory.createModal(AdminAvailableModals.CONFIRM_DISABLE_USER, this.selectedUsers.userIds.length);
        break;
      default:
        break;
    }
  }

  updateUserStatus = (ids: string[], action: string) => {
    const self = this;

    let successMessage: TemplateRef<any>;
    let errorMessage: TemplateRef<any>;

    switch (action) {
      case 'ENABLE':
        successMessage = self.toasterSuccessReactivateUser;
        errorMessage = self.toasterFailReactivateUser;
        break;
      case 'DISABLE':
        successMessage = self.toasterSuccessDeactivateUser;
        errorMessage = self.toasterFailDeactivateUser;
        break;
      case 'MAKE_ADMIN':
        successMessage = self.toasterSuccessGrantAdmin;
        errorMessage = self.toasterFailGrantAdmin;
        break;
      case 'REVOKE_ADMIN':
        successMessage = self.toasterSuccessRemoveAdmin;
        errorMessage = self.toasterFailRemoveAdmin;
        break;
    }

    this.adminUserService.updateUserStatus(ids, action).subscribe(response => {
      self.notifications.success(self.generateHTMLString('', successMessage));
      self.getUsers();
    }, error => {
      self.notifications.error(self.generateHTMLString('', errorMessage));
    });
  }
  private confirmBulkAction(action: string) {
    const self = this;

    let successMessage: TemplateRef<any>;
    let errorMessage: TemplateRef<any>;

    switch (action) {
      case 'ENABLE':
        successMessage = self.toasterSuccessReactivateUserBulk;
        errorMessage = self.toasterFailReactivateUserBulk;
        break;
      case 'DISABLE':
        successMessage = self.toasterSuccessDeactivateUserBulk;
        errorMessage = self.toasterFailDeactivateUserBulk;
        break;
      case 'MAKE_ADMIN':
        successMessage = self.toasterSuccessGrantAdminBulk;
        errorMessage = self.toasterFailGrantAdminBulk;
        break;
      case 'REVOKE_ADMIN':
        successMessage = self.toasterSuccessRemoveAdminBulk;
        errorMessage = self.toasterFailRemoveAdminBulk;
        break;
      default:
        break;
    }

    this.adminUserService.updateUserStatus(this.selectedUsers.userIds, action).subscribe(
      data => {
        self.selectedUsers.userIds = [];
        self.selectedUsers.allInstitutionUsers = false;
        self.selectedUsers.allUsersOnPage = false;

        if (successMessage) {
          self.notifications.success(self.generateHTMLString('', successMessage));
        }

        self.getUsers();
      },
      err => {
        console.error('Error:', err);
        if (errorMessage) {
          self.notifications.error(self.generateHTMLString('', errorMessage));
        }
      }
    );
  }

  public toggleSelectAllUsersOnPage() {
    for (let data of this.users) {
      data.user.selected = this.selectedUsers.allUsersOnPage;
      if (this.selectedUsers.allUsersOnPage) { // If the user checked "All users on page"
        // if the users is in the selected users list, doesn't have an 'invited' status, AND has actions (not the current user)
        if (_.indexOf(this.selectedUsers.userIds, data.user.id) < 0 && this.hasActions(data.user)) {
          this.selectedUsers.userIds.push(data.user.id); // Add the user to the list
        }
      } else { // If the user unchecked "All users on page"
        if (_.indexOf(this.selectedUsers.userIds, data.user.id) > -1) { // If the user is in the selectedUsers list
          this.selectedUsers.userIds.splice(_.indexOf(this.selectedUsers.userIds, data.user.id), 1); // Remove the user from the list
        }
      }
    }
    if (!this.selectedUsers.allUsersOnPage) {
      this.selectedUsers.allInstitutionUsers = false;
    }

    this.updateIndeterminateState();
  }

  public toggleSingleUser(id: string) {
    const i = this.selectedUsers.userIds.findIndex(function(item) {
      return item === id;
    });
    if (i > -1) {
      this.selectedUsers.userIds.splice(i, 1);
      this.selectedUsers.allUsersOnPage = false;
      this.selectedUsers.allInstitutionUsers = false;
    } else {
      this.selectedUsers.userIds.push(id);
    }
    this.checkUsersOnCurrentPage();
  }

  public deselectUsers() {
    this.selectedUsers.userIds = [];
    this.selectedUsers.allInstitutionUsers = false;
    this.selectedUsers.allUsersOnPage = false;
    for (let data of this.users) {
      data.user.selected = false;
    }
  }

  private checkUsersOnCurrentPage() {
    for (let data of this.users) {
      data.user.selected = (this.findNeedle(data.user.id, this.selectedUsers.userIds) !== undefined);
    }
    this.selectedUsers.allUsersOnPage = this.checkIfAllUsersOnCurrentPageSelected();
    this.updateIndeterminateState();
  }

  public checkIfAllUsersOnCurrentPageSelected() {
    const userIDs = this.users.map(data => data.user.id);
    return userIDs.every(id => this.selectedUsers.userIds.includes(id));
  }

  private updateIndeterminateState() {
    const selectedCount = this.users.filter(data => data.user.selected).length;
    this.isIndeterminateUsers = selectedCount > 0 && selectedCount < this.users.length;
  }

  searchEmail() {
    clearTimeout(this.searchTimer);
    this.isTimerExpired = false;
    if (this.emailSearch && this.emailSearch.length >= 3) {
      this.currentPage = 0;
      this.start = 0;
      this.searchTimer = setTimeout(() => {
        this.isTimerExpired = true;
        this.getPage(0, this.emailSearch);
      }, 2000);
    }
  }

  searchOnEnter() {
    this.currentPage = 0;
    this.start = 0;
    this.getPage(0, this.emailSearch);
  }
  handleBackspace(event: KeyboardEvent) {
    if ((event.keyCode === 8 && this.emailSearch.trim() === '') || (this.emailSearch && this.emailSearch.length >= 3)) {
      this.searchTimer = setTimeout(() => {
        this.isTimerExpired = true;
        this.getPage(0, this.emailSearch);
      }, 2000);
    }
  }
  nextPage() {
    if (this.end >= this.totalCountOfUsers) {
      return;
    }
    if ((this.start + this.pageSize) >= this.totalCountOfUsers) {
      this.start = this.totalCountOfUsers - this.end;
      this.end = this.totalCountOfUsers;
    } else {
      this.start = this.start + this.pageSize;
    }
    this.currentPage += 1;
    this.getPage(this.currentPage, this.email, false);
    this.checkUsersOnCurrentPage();
  }

  previousPage() {
    if (this.currentPage === 0 || this.start === 0) {
      return;
    }
    this.start = this.start - this.pageSize;
    this.currentPage -= 1;
    this.getPage(this.currentPage, this.email, false);
    this.checkUsersOnCurrentPage();
  }
  private findNeedle (needle, haystack) {
    return haystack.find(function(x) {
      return x === needle;
    });
  }

  private generateHTMLString(string, node): string {
    return string += node.nativeElement.innerHTML;
  }

  singleAction(user: User, action: string) {
    this.singleUser = user;
    switch (action) {
      case 'admin':
        this.modalFactory.createModal(AdminAvailableModals.CONFIRM_MAKE_USER_ADMIN, user.email);
        break;
      case 'remove':
        this.modalFactory.createModal(AdminAvailableModals.CONFIRM_REMOVE_USER_ADMIN, user.email);
        break;
      case 'disable':
        this.modalFactory.createModal(AdminAvailableModals.CONFIRM_DISABLE_USER, user.email);
        break;
      case 'enable':
        this.modalFactory.createModal(AdminAvailableModals.CONFIRM_ENABLE_USER, user.email);
        break;
      case 'report':
        this.modalFactory.createModal(AdminAvailableModals.REPORT_DOWNLOAD_NOTIFICATION, user.email);
        break;
      default:
        break;
    }
  }

  isCJKLanguage () {
    let currLocale = this.route.parent.snapshot.data['user'].preferences.language || 'en';
    let cjkLocales = ['ko', 'ja', 'zh', 'zh-cn', 'zh-tw'];
    return cjkLocales.indexOf(currLocale) > -1;
  }

  handleResponse(response: ModalResponseData<any>) {
    let ids = [];
    if (response.modalResult !== ModalResponseResult.CLOSE) {
      if (!this.singleUser) {
        this.confirmBulkAction(this.bulkActionToPerform);
      } else {
        ids = [this.singleUser.id];
        switch (response.modalId) {
          case AdminAvailableModals.CONFIRM_ENABLE_USER:
            if (response.modalResult === ModalResponseResult.CONFIRM) {
              this.updateUserStatus(ids, 'ENABLE');
            } else {
              this.singleUser = null;
            }
            break;
          case AdminAvailableModals.CONFIRM_MAKE_USER_ADMIN:
            if (response.modalResult === ModalResponseResult.CONFIRM) {
              this.updateUserStatus(ids, 'MAKE_ADMIN');
            } else {
              this.singleUser = null;
            }
            break;
          case AdminAvailableModals.CONFIRM_DISABLE_USER:
            if (response.modalResult === ModalResponseResult.CONFIRM) {
              this.updateUserStatus(ids, 'DISABLE');
            } else {
              this.singleUser = null;
            }
            break;
          case AdminAvailableModals.CONFIRM_REMOVE_USER_ADMIN:
            if (response.modalResult === ModalResponseResult.CONFIRM) {
              this.updateUserStatus(ids, 'REVOKE_ADMIN');
            } else {
              this.singleUser = null;
            }
            break;
          default:
            break;
        }
      }
    }
  }

  getNumFilters() {
    var count = [this.roleOptions, this.areaOptions, this.additionalOptions, this.statusOptions].filter(list => list.some(opt => !opt.checked)).length
    count += this.adminOnly ? 1 : 0;
    return count;
  }

  onResize() {
    this.updateMargins();
  }

  // for sticky fields of the table
  updateMargins() {
    const table = document.getElementById('users');
    const first = document.getElementsByClassName('fixed-left-first');
    const second = document.getElementsByClassName('fixed-left-second');
    const third = document.getElementsByClassName('fixed-left-third');
    const right = document.getElementsByClassName('fixed-right');
    right[0].parentElement.parentElement
    Array.from(second).forEach(item => {
      item.setAttribute('style', `left:${first[0].clientWidth}px`);
    });
    Array.from(third).forEach(item => {
      item.setAttribute('style', `left:${first[0].clientWidth + second[0].clientWidth}px`);
      table.clientWidth < table.scrollWidth && table.scrollLeft > 0 ? item.classList.add('fixed-left-sticking') : item.classList.remove('fixed-left-sticking');
    });
    Array.from(right).forEach(item => {
      table.clientWidth < table.scrollWidth && table.scrollLeft < table.scrollWidth-table.clientWidth ? item.classList.add('fixed-right-sticking') : item.classList.remove('fixed-right-sticking');
    });
  }
}
